<onyx-icon
  class="f-muted"
  [name]="iconName()"
  [size]="16"
  [onyxTooltip]="tooltipContent()"
  [onyxTooltipDelay]="TOOLTIP_DELAY"
></onyx-icon>
